import React from 'react';

const ArrowLeftBlack = () => {
    return (
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 16L1 8.5L9.5 1" stroke="black"/>
        </svg>

    );
};

export default ArrowLeftBlack;
